import FP from 'fingerprintjs2'
import md5 from 'blueimp-md5'
import { getDevices, saveCurrentDeviceId } from './devices'
import {
  getPlugins,
  getWebglVendorAndRenderer,
  getSystemAndVersion,
  getBrandAndModal,
  getTimezone,
  getCanvas,
  getDeviceName,
} from './util'
import httpRequest from '../httpRequest'
import isElectron from '../isElectron'

const bnbDeviceInfo = {
  info: {},
}

const key = '__DI__'

const excludesFpOptions = {
  colorDepth: true,
  deviceMemory: true,
  pixelRatio: true,
  hardwareConcurrency: true,
  sessionStorage: true,
  localStorage: true,
  indexedDb: true,
  addBehavior: true,
  openDatabase: true,
  cpuClass: true,
  doNotTrack: true,
  adBlock: true,
  hasLiedLanguages: true,
  hasLiedResolution: true,
  hasLiedOs: true,
  hasLiedBrowser: true,
  touchSupport: true,
  fonts: true,
  fontsFlash: true,
  enumerateDevices: true,
}

const preloadDeviceInfo = cb => {
  const execute = components => {
    const result = {}
    components.forEach(item => {
      result[item.key] = item.value
    })

    let plugins = getPlugins(result.plugins || result.regular_plugins || result.ie_plugins)

    if (plugins.length > 500) {
      const pluginsList = plugins
        .substr(0, 500)
        .split(',')
        .slice(0, -1)
      plugins = pluginsList.join(',')
    }

    const webgl = getWebglVendorAndRenderer(result.webgl)
    const res = {
      screen_resolution: result.screenResolution.join(','),
      available_screen_resolution: result.availableScreenResolution.join(','),
      system_version: getSystemAndVersion(),
      brand_model: getBrandAndModal(),
      system_lang: result.language,
      timezone: getTimezone(),
      timezoneOffset: result.timezoneOffset,
      // web
      user_agent: result.userAgent,
      list_plugin: plugins,
      canvas_code: getCanvas(result.canvas),
      webgl_vendor: webgl.vendor,
      webgl_renderer: webgl.renderer,
      audio: result.audio,
      platform: result.platform,
      web_timezone: result.timezone,
      device_name: getDeviceName(),
    }

    const values = Object.keys(res)
      .sort()
      .map(k => res[k])
    res.fingerprint = FP.x64hash128(values.join(''), 32)

    bnbDeviceInfo.info = res
    cb && cb(res)
  }

  try {
    FP.get({ excludes: excludesFpOptions }, execute)
  } catch (err) {
    console.error('fingerprint error: ', err)
    cb && cb(bnbDeviceInfo.info)
  }
}

const getCurrentDeviceId = address => {
  const deviceInfo = window.localStorage.getItem(key)
  return deviceInfo && JSON.parse(deviceInfo)?.[address]?.[0]
}

const getDeviceInfo = address => {
  let result = ''

  try {
    const { info } = bnbDeviceInfo

    // get device_id
    info.device_id = getCurrentDeviceId(address)
    // get related_device_ids
    const addressMd5 = md5(address)
    const devices = getDevices()
    const keys = Object.keys(devices).filter(k => k !== addressMd5)
    const deviceIds = keys.map(k => devices[k].value)
    info.related_device_ids = deviceIds.join(',')
    result = info
  } catch (err) {
    console.error('fingerprint error: ', err)
  }
  return result
}

const storeDeviceInfo = data => {
  const existInfo = window.localStorage.getItem(key)
  const deviceInfo = existInfo ? JSON.parse(existInfo) : {}
  if (deviceInfo[data.address]) {
    if (!deviceInfo[data.address].find(d => d === data.deviceId)) {
      deviceInfo[data.address].push(data.deviceId)
    }
  } else {
    deviceInfo[data.address] = [data.deviceId]
  }

  window.localStorage.setItem(key, JSON.stringify(deviceInfo))
}

export const setFingerPrint = async (deviceInfo, operation, address, txHash) => {
  try {
    if (!deviceInfo.device_id) {
      deviceInfo.device_id = getCurrentDeviceId(address)
    }

    if (isElectron()) {
      operation = `${operation}_trubi`
    }

    const fp = {
      deviceInfo,
      operation,
      address,
      txHash,
    }

    import('bson').then(async ({ serialize }) => {
      try {
        const body = serialize(fp)
        const result = await httpRequest.sendFingerPrint(body)
        storeDeviceInfo({ address, deviceId: result.device_id })
      } catch (err) {
        console.log(err)
      }
    })
  } catch (err) {
    console.log(err)
  }
}

// preload deviceInfo
if (typeof window !== 'undefined') {
  if (window.requestIdleCallback) {
    window.requestIdleCallback(() => {
      preloadDeviceInfo()
    })
  } else {
    setTimeout(() => {
      preloadDeviceInfo()
    }, 500)
  }
}

bnbDeviceInfo.getCurrentDeviceId = getCurrentDeviceId
bnbDeviceInfo.saveCurrentDeviceId = saveCurrentDeviceId
bnbDeviceInfo.getInfo = getDeviceInfo

export default bnbDeviceInfo
